import { inactiveUsersTypes } from './actionTypes';

export const getInactiveUsersList = () => {
  return {
    type: inactiveUsersTypes.GET_INACTIVE_USERS,
  };
};

export const getInactiveUsersListSuccess = (payload: any) => ({
  type: inactiveUsersTypes.GET_INACTIVE_USERS_SUCCESS,
  payload,
});

export const getInactiveUsersListFail = (error: any) => ({
  type: inactiveUsersTypes.GET_INACTIVE_USERS_FAIL,
  payload: error,
});

//ACTIVE USER------
export const activeUser = (user: any) => {
  return {
    type: inactiveUsersTypes.ACTIVE_USER,
    payload: user,
  };
};

export const activeUserSuccess = (user: any) => {
  return {
    type: inactiveUsersTypes.ACTIVE_USER_SUCCESS,
    payload: user,
  };
};

export const activeUserFail = (user: any) => {
  return {
    type: inactiveUsersTypes.ACTIVE_USER_FAIL,
    payload: user,
  };
};
